import { models } from '@vote4dance/judging-sdk';
var ScheduleItemSdk = models.schedules.ScheduleItem;
export const ScheduleItem = ScheduleItemSdk;
